<template>
    <footer class="page-footer px-xl-4 px-sm-2 px-0 py-3">
      <div class="container-fluid d-flex flex-wrap justify-content-between align-items-center">
        <p class="col-md-4 mb-0 text-muted">© {{ new Date().getFullYear()}} BM, All Rights Reserved.</p>
        <ul class="nav col-md-4 justify-content-center justify-content-lg-end">
            <li class="nav-item"><a class="color-400 nav-link px-2" href="javascript:void(0);">Portfolio</a></li>
            <li class="nav-item"><a class="color-400 nav-link px-2" href="javascript:void(0);">FAQs</a></li>
        </ul>
      </div>
    </footer>
</template>
  
<script>
  export default {
    name: 'FooterComponent',
  }
</script>
  